import {callAPI, USER_TYPE} from "./api-service";

export class partnersService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  async create(data) {
    const result = await callAPI({
      userType: USER_TYPE.PARTNER_MANAGER,
      method: "POST",
      endpoint: "partners",
      needsToken: true,
      data: data
    });
    return result;
  }

  async createAsAdmin(data) {
    const result = await callAPI({
      userType: USER_TYPE.ADMIN,
      method: "POST",
      endpoint: "partners/admin",
      needsToken: true,
      data: data
    });
    return result;
  }

  async get(data) {
    const result = await callAPI({
      method: "GET",
      endpoint: "partners",
      userType: USER_TYPE.ADMIN,
      needsToken: true,
      params: data
    });
    return result;
  }

  async getPartnerUsers(data) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "partners/users",
      needsToken: true,
      params: data
    });
    return result;
  }

  async getPartnerInfo(id) {
    const result = await callAPI({
      method: "GET",
      endpoint: `partners/${id}`,
      userType: USER_TYPE.ADMIN,
      needsToken: true
    });
    return result;
  }

  async getPartnerLink(id) {
    const result = await callAPI({
      userType: USER_TYPE.ADMIN,
      method: "GET",
      endpoint: "partners/partnerlink/" + id,
      needsToken: false
    });
    return result;
  }
}
